export enum ActivationAllowedEnum {
  None = 1,
  BypassCode,
  ActivationCode
}

export namespace ActivationAllowedEnum {
  export function values() {
    return Object.keys(ActivationAllowedEnum).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
